import { useState, useCallback } from "react";

export default (initialState: boolean) => {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(() => setState((old) => !old), []);

  const setTrue = useCallback(() => setState(true), []);

  const setFalse = useCallback(() => setState(false), []);

  return [state, toggle, setTrue, setFalse, setState] as const;
};
